// extracted by mini-css-extract-plugin
export var container = "_j8-1";
export var editor = "_j8-2";
export var resizable = "_j8-3";
export var wrapper = "_j8-0";